export const FILTRO_CACHE_NSIR = 'FILTRO_CACHE_NSIR';

export const FILTRO_CLEAN = 'FILTRO_CLEAN';